import { ViewModel,View, ObservableArray } from "binder"
import  { InquiryListView } from "./inquiryList-view"
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IImportingPart } from "../../ipart";
import { FileSelectorViewModel } from "uicomponents";
import { ImportBillFileDownloader } from "../importBillFileDownloader";
import { downloadFile } from "src/uicomponents/components/utilities";

export class InquiryListViewModel extends ViewModel implements IImportingPart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<providers>();
        this.title = 'Inquiry';
    }
    
    GetDefaultView(): View <ViewModel> {
        return new InquiryListView();
    }
    public getTypeId(): string {
        return "VM-02B3AECF-BD69-4668-881E-EFB9A4F014D9"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<providers>) { this._items = v; } public get items(): ObservableArray<providers> { return this._items;} private _items: ObservableArray<providers>;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
    private _processId;
    needsProcessToLoad(): boolean {
        return true;
    }
    async load(processId: any): Promise<any> {
        try {
            if(stringIsNullOrEmpty(processId)==false)
                this._processId = processId;
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/ListInquiriesFormPurchaseProcess',{
                PurchaseProcessId : this._processId
            });
            this.items.update(...result.Inquiries.map((x,i)=>{
                let r = new providers(this);
                r.index= i+1;
                r.processId = this._processId;
                r.billId = x.BillId;
                r.providerCode = x.CustomerCode;
                r.providerId = x.CustomerId;
                r.providerName = x.CustomerName;
                r.billCode = x.FactorNo;
                r.billTime = x.FactorTime;
                r.fileId = x.FileId;
                r.fileName = x.FileName;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async save(provider:providers){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/CreateNewPurchaseInquiry',{
                ProviderId : provider.providerId,
                PurchaseProcessId : provider.processId,
                FileContent : provider.fileSelector.filecontent,
                FileName : provider.fileSelector.filename,
                ParentBillId : null,
                Products : provider.data.map(x=>{return {
                    MeasuredProductId : x[0],
                    Amount : x[4]
                }})
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.load(null);
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
                this.isLoading = false;
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            this.isLoading = false;
        } finally {
        }
    }
    async checkFile(file):Promise<any>{
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/VerifyExcelFile',{
                ExcelFile : file,
                ProductCodeColumn : 1,
                BrandColumn : 2,
                ShallFillColumns : [1,2,3],
                NumericColumns : [3]
            });
            return result;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}


export class providers extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InquiryListViewModel) {
        super(parent);
        this.fileSelector = new FileSelectorViewModel(this);
        this.fileSelector.onFileChoosed = ()=>this.fileChanged();
        this.downloader = new ImportBillFileDownloader();
        this.fileSelector.downloader = this.downloader;
        this._typedParent = parent;
    }

    private _typedParent : InquiryListViewModel;
    private downloader :ImportBillFileDownloader;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;

    public set providerId(v: string) { this._providerId = v; } public get providerId(): string { return this._providerId;} private _providerId: string;
    public set providerName(v: string) { this._providerName = v; } public get providerName(): string { return this._providerName;} private _providerName: string;
    public set providerCode(v: string) { this._providerCode = v; } public get providerCode(): string { return this._providerCode;} private _providerCode: string;

    public set billId(v: string) { 
        this._billId = v;
        this.downloader.purchaseBillId = v;
    } public get billId(): string { return this._billId;} private _billId: string;
    public set billCode(v: string) { this._billCode = v; } public get billCode(): string { return this._billCode;} private _billCode: string;
    public set billTime(v: string) { this._billTime = v; } public get billTime(): string { return this._billTime;} private _billTime: string;
    
    public set fileId(v: string) { 
        this._fileId = v; 
        this.fileSelector.fileid = v;
    } public get fileId(): string { return this._fileId;} private _fileId: string;
    public set fileName(v: string) { 
        this._fileName = v; 
        this.fileSelector.filename = v;
    } public get fileName(): string { return this._fileName;} private _fileName: string;
    
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public data:string[][];
    private async fileChanged(){
        try {
            let result =await this._typedParent.checkFile(this.fileSelector.filecontent);
            if(result.IsValid){
                this.data = result.Data;
                this.messageBoxConfirmSuccess("فایل بررسی و صحیح است.","صحت فایل")
            }else{
                downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                this.messageBoxConfirmWarning('ساختار فایل صحیح نیست','خطا در فایل');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ارتباط','خطا در ارتباط');
        } finally {
        }
    }

    async save(){
        this._typedParent.save(this);
    }
}

